export const getFirstSegment = () => window.location.pathname
  .substring(1)
  .split('/')[0];